export default __webpack_public_path__ + "static/media/chat-bots-screen-2.cf643dd9.jpg";